import { categories } from "@/mocks/chigua";

const colNav = [
  { title: "浏览图集", links: [
    { label: "本周热榜", href: "#hot" },
    { label: "事件时间线", href: "#timeline" },
    { label: "图集对比", href: "#gallery" },
    { label: "最新收录", href: "#latest" },
    { label: "常见问题", href: "#faq" },
  ] },
  { title: "内容说明", links: [
    { label: "关于吃瓜图集", href: "#about" },
    { label: "内容与版权说明", href: "#about" },
    { label: "隐私处理原则", href: "#faq" },
    { label: "投稿联系", href: "#about" },
  ] },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-200/70">
      <div className="mx-auto grid max-w-content gap-10 px-4 py-14 md:px-6 lg:grid-cols-[1.2fr_0.9fr_0.9fr_0.7fr]">
        <div>
          <a href="#top" className="flex items-center gap-2.5" aria-label="吃瓜图集">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-chat-history-line text-xl" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold text-foreground-950">吃瓜图集</span>
              <span className="text-[10px] text-foreground-500">按事件整理截图脉络</span>
            </span>
          </a>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
            吃瓜不迷路。按事件把聊天记录、朋友圈、微博与评论整理成时间线，多方说法并排对照，一键看懂来龙去脉。
          </p>
          <div className="mt-5 flex items-center gap-2">
            {["聊天记录", "朋友圈", "微博", "全程复盘"].map((t) => (
              <a
                key={t}
                href="#latest"
                className="whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-600 transition hover:bg-primary-500 hover:text-background-50"
              >
                {t}
              </a>
            ))}
          </div>
        </div>

        {colNav.map((col) => (
          <nav key={col.title} aria-label={col.title}>
            <h4 className="text-sm font-bold text-foreground-950">{col.title}</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {col.links.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-foreground-600 transition hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        ))}

        <div>
          <h4 className="text-sm font-bold text-foreground-950">内容分类</h4>
          <ul className="mt-4 flex flex-wrap gap-2">
            {categories.map((c) => (
              <li key={c.slug}>
                <a
                  href="#latest"
                  className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-background-300/80 bg-background-50 px-3 py-1.5 text-xs text-foreground-600 transition hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={`${c.icon} text-primary-400`} />
                  {c.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200 bg-background-50/60">
        <div className="mx-auto flex max-w-content flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 吃瓜图集 · 按事件整理网络公开信息，仅供内容梳理参考</p>
          <p className="flex items-center gap-1">
            <i className="ri-arrow-up-line" />
            感谢你的关注，理性吃瓜，判断在你
          </p>
        </div>
      </div>
    </footer>
  );
}